module.exports = __webpack_public_path__ + "img/icon_sec6_02.c45ed9d9.png";